var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5ZM2.08333 12.5C2.08333 18.253 6.74703 22.9167 12.5 22.9167C15.2627 22.9167 17.9122 21.8192 19.8657 19.8657C21.8192 17.9122 22.9167 15.2627 22.9167 12.5C22.9167 6.74703 18.253 2.08333 12.5 2.08333C6.74703 2.08333 2.08333 6.74703 2.08333 12.5Z",
    fill: "#BA0303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4375 6.91666C11.4481 6.33084 11.9145 5.85534 12.5 5.83333C12.7661 5.80357 13.0323 5.88904 13.2313 6.06818C13.4304 6.24732 13.5433 6.50304 13.5417 6.77083V7.02083C13.5203 7.58703 13.0662 8.0411 12.5 8.06249C12.2262 8.08588 11.9552 7.99314 11.7531 7.80692C11.551 7.62069 11.4365 7.35812 11.4375 7.08333V6.91666ZM11.4583 11.1458C11.4583 10.5705 11.9247 10.1042 12.5 10.1042C13.0753 10.1042 13.5417 10.5705 13.5417 11.1458V18.2292C13.5417 18.8045 13.0753 19.2708 12.5 19.2708C11.9247 19.2708 11.4583 18.8045 11.4583 18.2292V11.1458Z",
    fill: "#BA0303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.099c672b897df0a91a7e6af383f4da57.svg";
export { ForwardRef as ReactComponent };